import React from "react";
import './ITR.scss';
import RoleResult from '../ruleResult/ruleResult';
import {commaSeparatRs} from '../../../../shared/common_logic';


const Profitability = ({fiveYear,lastClicked,profitability}) => {
    var year = lastClicked.split('-');
    var nextYear =  `${Number(year[0])+1}-${Number(year[1])+1}`;   

    return (
        <div className="col-md-12 itrdetails">
           
        <div className="row m-0 card" style={{ width: "100%", backgroundColor: "#F3F6FB", padding: "10px 10px 30px" }}>
        <div className="col-md-12">
            <div className="table-responsive">
                
                <table className="overflow-hidden">
                    <thead>
                    <tr >
                        <th className="tablehead font-weight-bold">Program Conditions ( Year on Year Comparison )</th>
                        <th className="font-weight-bold text-center">{nextYear}</th>
                        <th className="font-weight-bold text-center">{lastClicked}</th>
                        <th className="font-weight-bold text-center">Percentage Change</th>
                        
                    </tr>
                    </thead>
                    <tbody>
                            {profitability !== undefined ? 
                            <>
                            {Object.keys(profitability).map((data,index)=>(
                                
                                <tr key={index}>                                   
                                    <td className="tablehead">{profitability[data].title || "-"}</td>
                                    <td className="text-center">{profitability[data].value2 || "-"}</td>
                                    <td className="text-center">{profitability[data].value1 || "-"}</td>
                                    <td className="text-center">{profitability[data].value !==null ? String(profitability[data].value) : "-"}</td>
                                    {/* <RoleResult rule={profitability[data].result} id={index}/>  */}
                                    
                                    
                                </tr>
                            ))}
                            </>
                            :
                            <tr>
                            <td>-</td>
                            <td>-</td> 
                            <td>-</td>        
                        </tr>
                            }
                        </tbody>
                    {/* <tbody >
                          {1 > 0 ?
                        <>
                        {profitability.map((data,index)=>(
                        <tr key={index}>
                            <td className="tablehead">{data.title}</td>
                            <td className="text-center">
                            <div className="sub_text">
                                <div>{data.value !== undefined ? data.value : "-"}</div>
                                <div className={data.Sub_text !=="Increasing" ? "normal" :"increasing" }>{data.Sub_text !== undefined ? data.Sub_text : "-"}</div>
                            </div>
                            </td>
                            <RoleResult rule={data.result} comment={data.comments} id={index}/>
                        </tr>
                        ))}
                        </>
                        :
                        <tr>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                        </tr>}
                    </tbody> */}
                </table>
                
                </div>
            </div>
        </div>
  
    </div>

    );
};
export default Profitability;
